module.exports = __webpack_public_path__ + "img/pauli-y-root-dagger.153bd763.svg";